function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.728 44.25C18.4329 46.9127 25.6315 54.1363 25.6282 54.1431C25.6023 54.19 32.7804 47.0957 35.6391 44.2832L25.6663 34.4668L15.728 44.25Z",
  fill: "#3A1888"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.666 34.4671L35.6388 44.2834C35.6536 44.2673 35.6716 44.2479 35.688 44.2342L45.6514 34.4271L35.679 24.6104L25.666 34.4671Z",
  fill: "#03A1C4"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.6511 34.4272L45.6766 34.401C51.1873 28.9763 51.1914 20.1845 45.693 14.7529L35.6792 24.6105L45.6511 34.4272Z",
  fill: "#05D0DF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.6526 24.6104L5.7168 34.3916C5.71926 34.3944 5.72049 34.3984 5.72418 34.4005L15.7121 44.2338C15.7175 44.239 15.7228 44.2439 15.7285 44.2499L25.6664 34.4671L15.6526 24.6104Z",
  fill: "#761FE8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.666 14.7532L35.679 24.6108L45.6928 14.7532C45.6846 14.7476 45.6817 14.7431 45.6764 14.7367L35.688 4.90456C35.686 4.90133 35.6823 4.89931 35.6794 4.89648L25.666 14.7532Z",
  fill: "#FFAA01"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.67392 14.7871C0.212035 20.2183 0.225574 28.9777 5.71659 34.3919L15.6524 24.6107L5.67392 14.7871Z",
  fill: "#F1175D"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.6661 14.7533L15.6868 4.92969L5.72388 14.7367C5.70665 14.7533 5.69147 14.7715 5.67383 14.7872L15.6523 24.6109L25.6661 14.7533Z",
  fill: "#FB3A1B"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.6793 4.89623C30.1616 -0.525662 21.2256 -0.522431 15.7116 4.90431L15.687 4.92935L25.6663 14.753L35.6793 4.89623Z",
  fill: "#FBC935"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.9837 36.8846V26.8392C76.9837 24.366 75.6688 22.1213 73.078 22.1213C70.5261 22.1213 69.0205 24.366 69.0205 26.8392V36.8846H64.3057V18.0883H68.6725L69.0205 20.3726C70.0256 18.4687 72.2283 17.7842 74.0434 17.7842C76.3257 17.7842 78.6055 18.6985 79.6882 21.2845C81.3888 18.6214 83.594 17.8605 86.0654 17.8605C91.4781 17.8605 94.1444 21.1318 94.1444 26.7641V36.8846H89.428V26.7641C89.428 24.2913 88.3846 22.1968 85.8357 22.1968C83.2826 22.1968 81.6981 24.366 81.6981 26.8392V36.8846H76.9837Z",
  fill: "currentColor"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.05 18.1274H118.573V36.8841H114.127L113.895 34.1459C112.814 36.3518 109.838 37.4156 107.711 37.4548C102.07 37.4944 97.8936 34.0684 97.8936 27.4854C97.8936 21.0183 102.263 17.6327 107.829 17.6702C110.379 17.6702 112.813 18.8495 113.895 20.7142L114.05 18.1274ZM102.61 27.4858C102.61 31.062 105.122 33.1936 108.253 33.1936C115.673 33.1936 115.673 21.8175 108.253 21.8175C105.122 21.8175 102.61 23.91 102.61 27.4858Z",
  fill: "currentColor"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.555 44.7256V18.1278H126.963L127.269 20.7146C128.739 18.6213 131.291 17.709 133.455 17.709C139.328 17.709 143.235 22.0085 143.235 27.5253C143.235 33.0042 139.716 37.3417 133.609 37.3417C131.601 37.3417 128.623 36.7314 127.269 34.6782V44.7252H122.555V44.7256ZM138.52 27.5253C138.52 24.5961 136.509 22.1971 133.108 22.1971C129.706 22.1971 127.695 24.5961 127.695 27.5253C127.695 30.4534 129.899 32.8535 133.108 32.8535C136.317 32.8535 138.52 30.4538 138.52 27.5253Z",
  fill: "currentColor"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.661 12.4199V18.0882H158.155V19.6479H151.661V31.1007C151.661 33.6499 152.203 35.439 155.179 35.439C156.106 35.439 157.15 35.1341 158.116 34.6777L158.773 36.1975C157.574 36.7718 156.375 37.151 155.179 37.151C151.121 37.151 149.806 34.7916 149.806 31.1011V19.6483H145.747V18.0886H149.806V12.6101L151.661 12.4199Z",
  fill: "currentColor"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.036 11.9628C165.036 13.9413 161.982 13.9413 161.982 11.9628C161.982 9.98506 165.036 9.98506 165.036 11.9628ZM162.524 18.0127V36.8853H164.416V18.0127H162.524Z",
  fill: "currentColor"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.722 10.252V36.8849H169.828V10.252H171.722Z",
  fill: "currentColor"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.755 18.0885L201.832 21.4386C203.031 18.8874 205.737 17.8991 208.172 17.8991C209.603 17.8608 210.991 18.2408 212.268 19.0033L211.417 20.5247C210.415 19.916 209.291 19.6487 208.172 19.6487C204.614 19.6878 201.87 22.5024 201.87 25.9276V36.8852H199.976V18.0885H201.755Z",
  fill: "currentColor"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.163 30.6732C178.164 30.6749 178.166 30.6773 178.166 30.6789L193.625 26.6508C193.624 26.6447 193.623 26.6394 193.623 26.6338L178.163 30.6732Z",
  fill: "currentColor"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.621 35.7546C182.256 35.7546 179.373 33.6791 178.167 30.7313H178.156L178.165 30.7297C178.165 30.7285 178.164 30.7265 178.163 30.7252L193.622 26.6854C193.622 26.6922 193.623 26.6975 193.624 26.7036L195.27 26.2746C194.605 21.5135 190.539 17.8496 185.621 17.8496C180.239 17.8496 175.878 22.2368 175.878 27.6486C175.878 33.0604 180.239 37.4492 185.621 37.4492C189.646 37.4492 193.101 34.9929 194.587 31.4914L193.036 30.8278C191.808 33.7231 188.95 35.7546 185.621 35.7546ZM177.562 27.6482C177.562 23.1722 181.17 19.5426 185.621 19.5426C189.101 19.5426 192.066 21.7606 193.195 24.8696L177.663 28.9268C177.597 28.51 177.562 28.084 177.562 27.6482Z",
  fill: "currentColor"
});

var SvgMaptilerLogo = function SvgMaptilerLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "maptilerLogo",
    width: 215,
    height: 55,
    viewBox: "0 0 215 55",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMaptilerLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maptiler-logo.596e07a3.svg";
export { ForwardRef as ReactComponent };